module.exports = "/shifts/components/tips/multiselectShifts-f3bd68.html";